import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { actionDockSetExpandUsers } from '@/modules/application/actions/dock';
import Expand from './Expand';
import ListItem from './ListItem';

const Users = (props) => {
    return (
        <>
            <ListItem title="Пользователи" to="/users/">
                <Expand expand={props.expand} setExpand={props.setExpand}/>
            </ListItem>
            <Collapse in={props.expand}>
                <List disablePadding={true}>
                    <ListItem title="Администраторы" to="/users/admins/"/>
                    <ListItem title="Партнеры" to="/users/affiliates/"/>
                    <ListItem title="Клиенты" to="/users/clients/"/>
                </List>
            </Collapse>
        </>
    );
};

export default connect(
    (state) => ({
        expand: state.dock.expandUsers,
    }),
    (dispatch) => ({
        setExpand: bindActionCreators(actionDockSetExpandUsers, dispatch),
    }),
)(Users);
